module.exports = __webpack_public_path__ + "static/media/ServicePPB.adf55721.jpg";